import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ShowcaseLoyaltyActiveLotDto } from './ShowcaseLoyaltyActiveLotDto'
import { ShowcaseLoyaltyTierStateDto } from './ShowcaseLoyaltyTierStateDto'
/**
* Class ShowcaseLoyaltyWalletDto
*  Сводка кошелька лояльности текущего пользователя на витрине.
*/
export class ShowcaseLoyaltyWalletDto extends ActiveModel {

  /**
  * availableBalance
  * Доступный баланс.  */
  @ActiveField(0)
  availableBalance: number = 0


/**
  * @property activeLots
  * Активные лоты (FIFO-порядок списания).  */
  @ActiveField({
    factory: [ShowcaseLoyaltyActiveLotDto, () => []]
  })
  activeLots: Array<ShowcaseLoyaltyActiveLotDto> = []


  /**
  * tierState
  * Текущий tier; null, если ещё не рассчитан.  */
  @ActiveField({
    factory: [ShowcaseLoyaltyTierStateDto, () => undefined]
  })
  tierState?: null | ShowcaseLoyaltyTierStateDto
}
